import React, { memo } from 'react'
import { useHistory } from 'react-router-dom'
import styles from './styles.module.scss'
import { useTableCount } from './useTableCount.hook'
import ProgressBar from '../ProgressBar'

const TableCountPage: React.FC = () => {
  const history = useHistory()
  const { tableCount, formState, handleTableCountChange, handleSubmit } = useTableCount()

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    handleSubmit()
  }

  const handleNextClick = () => {
    if (tableCount.trim()) {
      handleSubmit()
    }
  }

  return (
    <>
      <ProgressBar />
      <div className={styles.tableCountPage}>
        <div className={styles.tableCountLeftSection}>
          <div className={styles.tableCountTextContainer}>
            <div className={styles.textContent}>
              <span className={styles.tableCountTitle}>How many tables will be at your reception?</span>
              <span className={styles.tableCountDescription}>
                If you're not sure, you can assume about 8 people per table.
              </span>
            </div>
            <button
              className={`${styles.tableCountButton} ${tableCount.trim() ? styles.hasValue : ''}`}
              onClick={handleNextClick}
              disabled={!tableCount.trim() || formState.isSubmitting}
            >
              Next
            </button>
          </div>
        </div>

        <div className={styles.tableCountRightSection}>
          <form onSubmit={handleFormSubmit} className={styles.tableCountForm}>
            <div className={`${styles.tableCountInputContainer} ${formState.error ? styles.hasError : ''}`}>
              <input
                className={styles.tableCountInput}
                placeholder="Your table count"
                value={tableCount}
                onChange={handleTableCountChange}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault()
                    handleFormSubmit(e)
                  }
                }}
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                aria-label="Table count"
                aria-invalid={formState.error ? 'true' : 'false'}
                aria-describedby={formState.error ? 'table-count-error' : undefined}
              />
              {formState.error && (
                <div id="table-count-error" className={styles.errorMessage} role="alert" aria-live="polite">
                  {formState.error}
                </div>
              )}
            </div>
          </form>
          <button
            className={`${styles.tableCountButtonMobile} ${tableCount.trim() ? styles.hasValue : ''}`}
            onClick={handleNextClick}
            disabled={!tableCount.trim() || formState.isSubmitting}
          >
            Next
          </button>
        </div>
      </div>
    </>
  )
}

TableCountPage.displayName = 'TableCountPage'

export default memo(TableCountPage)
